import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

// TZ10-3: поле поиска по витрине с debounce; onSearch получает уже обрезанную строку
export const TaskSearchInput = ({ value, onSearch, delay = 400 }) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => { setDraft(value); }, [value]);

  useEffect(() => {
    const q = draft.trim();
    if (q === value) return undefined;
    const id = setTimeout(() => onSearch(q), delay);
    return () => clearTimeout(id);
  }, [draft, value, onSearch, delay]);

  return (
    <div
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white w-full sm:w-64 focus-within:ring-2 focus-within:ring-teal-600/30"
      style={{ border: "1px solid var(--rv-border)" }}
      data-testid="task-search-wrapper"
    >
      <Search size={14} style={{ color: "var(--rv-text-muted)", flexShrink: 0 }} />
      <input
        type="text"
        enterKeyHint="search"
        data-testid="task-search-input"
        value={draft}
        maxLength={100}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="Поиск по заданиям"
        aria-label="Поиск по заданиям"
        className="flex-1 min-w-0 text-sm bg-transparent"
        style={{ color: "var(--rv-text-primary)", fontFamily: "IBM Plex Sans,sans-serif", outline: "none", boxShadow: "none", border: "none" }}
      />
      {draft && (
        <button
          type="button"
          data-testid="task-search-clear"
          onClick={() => { setDraft(""); onSearch(""); }}
          aria-label="Сбросить поиск"
          style={{ background: "none", border: "none", cursor: "pointer", padding: 0, color: "var(--rv-text-muted)" }}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
};
